import { define } from '../redux-request';
import api from '../../api/api';

export const GET_SCRIPTS = define('GET_SCRIPTS');

export function getScriptsRequest(data) {
  return GET_SCRIPTS.request(() => api.getScripts(data));
}

export const GET_PATIENT_SCRIPTS = define('GET_PATIENT_SCRIPTS');

export function getPatientScriptsRequest(data) {
  return GET_PATIENT_SCRIPTS.request(() => api.getScripts(data));
}

export const GET_SCRIPTS_NOTES = define('GET_SCRIPTS_NOTES');

export function getScriptsNotesRequest(data) {
  return GET_SCRIPTS_NOTES.request(() => api.getScriptsNotes(data));
}

export const ADD_SCRIPT_NOTE = define('ADD_SCRIPT_NOTE');

export function addScriptNoteRequest(data) {
  return ADD_SCRIPT_NOTE.request(() => api.addScriptNote(data));
}

export const EDIT_SCRIPT_NOTE = define('EDIT_SCRIPT_NOTE');

export function editScriptNoteRequest(data) {
  return EDIT_SCRIPT_NOTE.request(() => api.editScriptNote(data));
}

export const DELETE_SCRIPT_NOTE = define('DELETE_SCRIPT_NOTE');

export function deleteScriptNoteRequest(data) {
  return DELETE_SCRIPT_NOTE.request(() => api.deleteScriptNote(data)).onSuccess(() => data);
}

export const SCRIPT_NOTE_OR_ATTACHMENT_IDS = define('SCRIPT_NOTE_OR_ATTACHMENT_IDS');

export const scriptNoteOrAttachmentIds = ({ name, ids }) => ({
  type: SCRIPT_NOTE_OR_ATTACHMENT_IDS,
  payload: {
    name,
    ids,
  },
});

export const ADD_SCRIPT_NOTE_COPY = define('ADD_SCRIPT_NOTE_COPY');

export function addScriptNoteCopyRequest(data) {
  return ADD_SCRIPT_NOTE_COPY.request(() => api.addScriptNoteCopy(data));
}

export function addScriptAttachmentCopyRequest(data) {
  return ADD_SCRIPT_NOTE_COPY.request(() => api.addScriptAttachmentCopy(data));
}

export const CHANGE_SCRIPT_DATA = define('CHANGE_SCRIPT_DATA');

export function changeScriptData(data) {
  return {
    type: CHANGE_SCRIPT_DATA,
    payload: data,
  };
}

export const DELETE_SCRIPT_DATA = define('DELETE_SCRIPT_DATA');

export function deleteScriptData(id) {
  return {
    type: DELETE_SCRIPT_DATA,
    payload: id,
  };
}

export const ADD_SCRIPT = define('ADD_SCRIPT');

export function addScriptRequest(data) {
  return ADD_SCRIPT.request(() => api.addScript(data));
}

export const UPDATE_SCRIPT = define('UPDATE_SCRIPT');

export function updateScriptRequest(data) {
  return UPDATE_SCRIPT.request(() => api.updateScript(data));
}

export const BULK_UPDATE_SCRIPT = define('BULK_UPDATE_SCRIPT');

export function bulkUpdateScriptRequest(data) {
  return BULK_UPDATE_SCRIPT.request(() => api.updateScript(data));
}

export const UPDATE_SCRIPT_STATUSES = define('UPDATE_SCRIPT_STATUSES');

export function updateScriptStatusesRequest(data) {
  return UPDATE_SCRIPT_STATUSES.request(() => api.updateScriptStatuses(data));
}

export const GET_SCRIPT_STATUS = define('GET_SCRIPT_STATUS');

export function getScriptStatusRequest(data) {
  return GET_SCRIPT_STATUS.request(() => api.getScriptStatus(data));
}

export const GET_SCRIPT_PAYMENTS = define('GET_SCRIPT_PAYMENTS');

export function getScriptPaymentsRequest(data) {
  return GET_SCRIPT_PAYMENTS.request(() => api.getScriptPayments(data));
}

export const GET_SCRIPT_ATTACHMENTS = define('GET_SCRIPT_ATTACHMENTS');

export function getScriptAttachmentsRequest(data) {
  return GET_SCRIPT_ATTACHMENTS.request(() => api.getScriptAttachments(data));
}

export const UPLOAD_ATTACHMENT_FILE = define('UPLOAD_ATTACHMENT_FILE');

export function uploadAttachmentFileRequest(data) {
  return UPLOAD_ATTACHMENT_FILE.request(() => api.uploadAttachmentFile(data));
}

export const SET_SCROLLING_TO_NOTE = define('SET_SCROLLING_TO_NOTE');

export function setScrollingToNoteId(id) {
  return {
    type: SET_SCROLLING_TO_NOTE,
    payload: id,
  };
}

export const DELIVERY_METHOD = define('DELIVERY_METHOD');

export function showShippingLabel(data) {
  return {
    type: DELIVERY_METHOD,
    payload: data,
  };
}

export const US_POSTAL_RESPONSE = define('US_POSTAL_RESPONSE');

export function sendDeliveryPriceRequest(data) {
  return US_POSTAL_RESPONSE.request(() => api.sendDeliveryPrice(data));
}

export const POSTAL_SERVICES_DATA = define('POSTAL_SERVICES_DATA');

export function deliveryPostalServicesData(data) {
  return {
    type: POSTAL_SERVICES_DATA,
    payload: data,
  };
}
